module.exports = __webpack_public_path__ + "img/STRATACACHE logo - White.7c78ccf1.svg";